/* eslint-disable no-unused-vars */

enum ScienceType {
  noDegree,
  candidateOfSciences,
  doctorOfSciences,
  professor,
}

const SCIENCES = {
  [ScienceType.noDegree]: ['Нет', 'Нет'],
  [ScienceType.candidateOfSciences]: ['к.м.н.', 'Кандидат наук'],
  [ScienceType.doctorOfSciences]: ['д.м.н.', 'Доктор наук'],
  [ScienceType.professor]: ['Профессор', 'Профессор'],
}

export default function filterGetTextScience(science: 0 | 1 | 2 | 3, isShort: boolean) {
  return SCIENCES[science][isShort ? 0 : 1]
}
